import * as DialogPrimitive from '@radix-ui/react-dialog';
import { ExternalLink, FileText, X } from 'lucide-react';
import { documentPagePath, textOf, useViewerFile, ViewerBody } from './ViewerContent';
import styles from './document-viewer.module.css';

// A document opened over the current page, centred, with the page behind it
// dimmed and blurred. View only — no download or print. The file comes through
// the same permission- and tenant-checked download the Documents tab uses.
const DocumentViewer = ({ documentId, open, onClose, title }) => {
  const [state, fail] = useViewerFile(documentId, open);

  return (
    <DialogPrimitive.Root open={open} onOpenChange={(next) => !next && onClose()}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className={styles.overlay} />
        <DialogPrimitive.Content
          className={styles.content}
          aria-describedby={undefined}
          onEscapeKeyDown={(e) => {
            // Esc in the search box closes the search, not the document.
            if (e.target?.closest?.('[data-viewer-search]')) e.preventDefault();
          }}
        >
          <header className={styles.header}>
            <FileText className={styles.fileIcon} aria-hidden="true" />
            <DialogPrimitive.Title className={styles.fileName}>{title || 'Document'}</DialogPrimitive.Title>
            {documentId && (
              // The same view in a tab of its own. A link rather than a
              // script-opened window, so no popup blocker stands in the way
              // and a middle-click works as it does on any link.
              <a
                href={documentPagePath(documentId, textOf(title))}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.newTab}
                aria-label="Open in new tab"
                title="Open in new tab"
              >
                <ExternalLink aria-hidden="true" />
              </a>
            )}
            <DialogPrimitive.Close className={styles.close} aria-label="Close document">
              <X aria-hidden="true" />
            </DialogPrimitive.Close>
          </header>
          <div className={styles.body}>
            <ViewerBody state={state} onError={fail} name={textOf(title)} />
          </div>
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
};

export default DocumentViewer;
